import { PageHeader } from "@shared/components/PageHeader";
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import { CreditCard, Map, MapPinned } from "lucide-react";

// const GIS_INTEGRATION_CARDS: IntegrationCardConfig[] = [
//   {
//     title: "ArcGIS",
//     description:
//       "Connects SMART360 with ArcGIS to visualize and manage utility data on interactive maps.",
//     status: "not_connected",
//     icon: Map,
//     comingSoon: true,
//     connectPath: "/integration-hub/gis-integration/arcgis/connect",
//     configurePath: "/integration-hub/gis-integration/arcgis/configure",
//     detailsPath: "/integration-hub/gis-integration/arcgis/details",
//   },
//   {
//     title: "Esri GIS",
//     description:
//       "Integrates SMART360 with Esri to enable advanced spatial analysis and location-based insights.",
//     status: "not_connected",
//     icon: MapPinned,
//     comingSoon: true,
//     connectPath: "/integration-hub/gis-integration/esri/connect",
//     configurePath: "/integration-hub/gis-integration/esri/configure",
//     detailsPath: "/integration-hub/gis-integration/esri/details",
//   },
// ];

const GisIntegrationLanding = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="GIS Integration"
        subtitle="Link mapping systems for asset intelligence, territory planning, and network visualization."
      />
      <IntegrationCardGrid cards={[]} />
    </div>
  );
};

export default GisIntegrationLanding;
